// Live-syncs the theme lab's state onto every other open page of the app, in
// the same browser, without a reload. `ThemeLab.js` posts its current state
// onto a `BroadcastChannel` whenever it changes; this listens for it and
// re-applies the same style the lab hook applies to its own document.
//
// Only wired up when a theme preview is active (see the `#theme-live` marker
// rendered by the root layout) — a page with no preview has nothing to sync
// against, so `startThemeLive()` is called from `app.js` behind that guard.
const CHANNEL = "theme-lab";
const FONT_LINK_ID = "theme-live-font";

function applyFont(href) {
  let link = document.getElementById(FONT_LINK_ID);

  if (!href) {
    link?.remove();
    return;
  }

  if (!link) {
    link = document.createElement("link");
    link.id = FONT_LINK_ID;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  link.href = href;
}

export function startThemeLive() {
  const channel = new BroadcastChannel(CHANNEL);

  channel.onmessage = ({ data }) => {
    if (data?.type !== "state") return;

    document.documentElement.style.cssText = data.style || "";
    applyFont(data.fontStylesheet);
  };

  // An editor tab already open replies with its current state.
  channel.postMessage({ type: "hello" });
}
